// extracted by mini-css-extract-plugin
export var deliveryRow = "_kg-a";
export var fixedHeight = "_kg-4";
export var freightLogo = "_kg-9";
export var fullWidth = "_kg-3";
export var priceColumn = "_kg-5";
export var radioSelected = "_kg-7";
export var radioUnselected = "_kg-6";
export var selectedOption = "_kg-2";
export var selectedOptionContainer = "_kg-1";
export var selection = "_kg-0";
export var tallSkeletonText = "_kg-8";